var React = require('react');

function FilterTopButtonIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E1E1E","fillRule":"evenodd","d":"M18.67 1.205c-.439-.464-1.15-.464-1.59 0L7.148 11.702 1.92 6.176c-.44-.464-1.151-.464-1.59 0-.44.465-.44 1.217 0 1.681l6.023 6.366c.22.233.507.348.795.348.288 0 .576-.116.795-.348L18.671 2.886c.439-.464.439-1.217 0-1.68","opacity":".7"}));
}

FilterTopButtonIcon.defaultProps = {"width":"19","height":"15","viewBox":"0 0 19 15"};

module.exports = FilterTopButtonIcon;

FilterTopButtonIcon.default = FilterTopButtonIcon;
